import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ImageUpload } from '../../components/Icons';
import { Trash } from 'react-bootstrap-icons';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { toast_error, toast_success } from '../../config/Constant';
import { setLoader } from '../../slice/commonSlice';
import { createDispute } from '../../services/auth.service';
import { selectUser } from '../../slice/authSlice';

const RaiseDispute = (props) => {
  const user = useSelector(selectUser);

  const [inputFile, setInput] = useState(null);
  const [disputeText, setDisputeText] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactNumber, setContactNumber] = useState('');

  const [image, setImage] = useState(null);
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("userId", props.disputeJob?.userId?._id);
    formData.append("providerId", props.disputeJob?.providerId?._id);
    if(user?.userType === "user") {
      formData.append("userDescription", disputeText);
      if(inputFile){
      formData.append("userDisputePicture", inputFile);
      }
    }else {
      formData.append("providerDescription", disputeText);
      formData.append("contactEmail",contactEmail);
      formData.append("contactNumber",contactNumber);

      if(inputFile){
          formData.append("providerDisputePicture", inputFile);
      }
    }
    formData.append("jobId", props.disputeJob?.jobId);
    formData.append("serviceId", props.disputeJob?.serviceId?._id);
    formData.append("serviceName", props.disputeJob?.serviceId?.name || props.disputeJob?.serviceName);

    // await dispatch(setLoader(true));
    try {
      const response = await createDispute(formData);
      if(response.status){
        toast.success(response?.data?.message, toast_success);
        props.handleDisputeSuccess();
        await dispatch(setLoader(false));
        props.setDisputeModal(false)
      }
    } catch (error) {
      toast.error(error?.data?.message, toast_error)
      await dispatch(setLoader(false));
      props.setDisputeModal(false)
      console.error("Error data:", error);
    }
  };

  const onFileChange = (e) => {
    setInput(e.target.files[0]);
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setInput(null);
    setImage('');
  };

  return (
    <>
      <Modal
        size="sm"
        show={props.disputeModal}
        onHide={() => props.setDisputeModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className='pt-0'>
          <h2 className='modal-title text-center'>Raise Dispute</h2>
          <Form className='modal-form-wrapper' enctype="multipart/form-data" onSubmit={(e) => handleSubmit(e)}>
            <Form.Group className="mb-4" controlId="file">
            <div className='tab-wrapper'>
              <div className='file-upload-wrapper'><Form.Group className="mb-4" controlId="describe">
              <Form.Control
                as="textarea"
                placeholder="Email"
                name="contactEmail"
                onChange={(e) => setContactEmail(e.target.value)}
                rows={1}
              />
            </Form.Group>
            <Form.Group className="mb-4" controlId="describe">
              <Form.Control
                as="textarea"
                placeholder="Phone Number"
                name="contactNumber"
                onChange={(e) => setContactNumber(e.target.value)}
                rows={1}
              />
            </Form.Group>

                {image ? (
                   <div className='document-proof-wrapper'>
                    <div className='doc-img'>
                      <img src={image} alt='User' />
                    </div>
                    <div className='trash-icon' onClick={handleRemoveImage}>
                      <Trash />
                    </div>
                  </div>
                ) : (

                  <label htmlFor='profilePic'>
                    <ImageUpload />
                    <span>
                      Upload
                      Picture
                    </span>
                    <input id="profilePic" type='file' name="profilePic" onChange={onFileChange} />
                  </label>
                )}
              </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="describe">
              <Form.Control
                as="textarea"
                placeholder="Describe"
                name="describe"
                onChange={(e) => setDisputeText(e.target.value)}
                rows={3}
              />
            </Form.Group>
            <Form.Group className='mb-4'>
              <div className="d-grid">
                <Button type="submit" variant="primary" disabled={!disputeText} size="lg" onClick={handleSubmit}>
                  Dispute
                </Button>

              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default RaiseDispute
